import { render, staticRenderFns } from "./publishAdvancedForm.vue?vue&type=template&id=55362e4b&scoped=true&"
import script from "./publishAdvancedForm.vue?vue&type=script&lang=js&"
export * from "./publishAdvancedForm.vue?vue&type=script&lang=js&"
import style0 from "./publishAdvancedForm.vue?vue&type=style&index=0&id=55362e4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55362e4b",
  null
  
)

export default component.exports